/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const PostgresVersionGet = {
  id: 'postgres-version.get',
  tag: 'Product',
  summary: 'Get Postgres version',
  description: 'Get cluster postgres versions',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/product/pgversion`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            versions: z.array(z.number()),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
